import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {IChangeModalPayload, IModalContainerInitialState} from "./index";



const initialState:IModalContainerInitialState={
    modals: {},
    isBackgroundOpen:false,
}



const modalContainerSlice = createSlice({
    name: "modalContainer",
    initialState,
    reducers: {
        changeModal: (state, action: PayloadAction<IChangeModalPayload>) => {
            const { modalId, status } = action.payload;
            if(status === "open" ){
                state.isBackgroundOpen = true
            }
            else{
                state.isBackgroundOpen = false
            }

            state.modals[modalId] = status === "open";
        },
    },
});


export const { changeModal } = modalContainerSlice.actions;
export default modalContainerSlice;
